export default __webpack_public_path__ + "20cf63ba38e0ce59fab28ef29ff7ffbb.svg";